import { Pipe, PipeTransform } from '@angular/core';
import { DEFAULT_IMAGE } from '../contants';

@Pipe({
     name: 'defaultAsset',
})
export class DefaultAssetPipe implements PipeTransform {
     constructor() {}

     transform(value: any, ...args: any[]): any {
          if (value) {
               return value;
          } else {
               if (!value && args) {
                    return DEFAULT_IMAGE[args[0]];
               } else {
                    return '';
               }
          }
     }
}
